import classNames from "classnames/bind";
import styes from './FormParamAiConfig.module.css';
import { Fragment, useEffect, useRef, useState } from "react";
import { Select } from "antd";
import { DownIcons } from "../../../../../../components/Icons/Icons";
import { Chip, Switch } from "../../../../../../components";
import { convertTimePM, listParamTranslate } from "../../../../../../utils";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styes);

const FormParamAiConfig = ({ value, onChange, listParamConfig }) => {
    const refBtn = useRef(null)
    const ref = useRef(null)
    const [isFormTime, setIsFormTime] = useState(false)
    const { t } = useTranslation();
    useEffect(() => {
        let handler = (e) => {
            if (!refBtn?.current?.contains(e.target)) {
                if (!ref?.current?.contains(e.target)) {
                    setIsFormTime(false);
                }
            }
        };
        document.addEventListener("click", handler);
        return () => {
            document.removeEventListener("click", handler);
        };
    }, []);
    const getElementConfig = (element) => {
        switch (element?.type) {
            case 'select':
                return (<label className={cx('item-setting')}>
                    <p className={cx('name')}>{listParamTranslate?.find(item => item?.param_name === element?.label)?.name_tr || element?.label}</p>
                    <Select
                        options={element?.options || []}
                        className={cx('select')}
                        placeholder={"Tất cả"}
                        notFoundContent={<></>}
                        suffixIcon={<DownIcons />}
                        onChange={(val) => onChange(element?.param, val)}
                        defaultValue={value[element?.param] || ''}
                        value={value[element?.param] || ''}
                    >
                    </Select>
                </label>)
            case 'switch':
                return (<label className={cx('item-setting')}>
                    <p className={cx('name')}>{listParamTranslate?.find(item => item?.param_name === element?.label)?.name_tr || element?.label}</p>
                    <Switch type="small" value={value[element?.param] === 1} onChange={(val) => onChange(element?.param, val ? 1 : 0)} />
                </label>)
            case 'input':
                return (<label className={cx('item-setting')}>
                    <p className={cx('name')}>{listParamTranslate?.find(item => item?.param_name === element?.label)?.name_tr || element?.label}</p>
                    <input
                        className={cx('input')}
                        type={'number'}
                        value={value[element?.param] || ''}
                        onChange={(e) => onChange(element?.param, e.target.value)}
                        max={14}
                        min={1}
                    />
                </label>)
            case 'time':
                return (
                    <div className={cx("item-setting")}>
                        <span style={{ flex: 1 }} className={cx("name")}>
                            {t('settingCam.Time_frame_allowed')}
                        </span>
                        <span
                            style={{
                                flex: 2,
                                display: "flex",
                                gap: 6,
                                flexWrap: "wrap",
                                flexDirection: "row-reverse",
                                marginTop: 0,
                            }}
                            className={cx("info")}
                            onClick={() => {
                                setIsFormTime(!isFormTime);
                            }}
                        >
                            <span ref={refBtn} className={cx("list-time")}>
                                {value?.time_start && value?.time_end && (
                                    <Chip
                                        title={`${convertTimePM(value?.time_start)} - ${value?.time_end === "00" ? "24" : convertTimePM(value?.time_end)
                                            }`}
                                        onClose={() => 0}
                                    />
                                )}
                            </span>
                        </span>
                        {isFormTime && (
                            <div ref={ref} className={cx("time")}>
                                <div className={cx("start")}>
                                    <label className={cx("label-time")}>{t("smartReport.timeStart")}</label>
                                    <input
                                        value={value?.time_start}
                                        onChange={(e) => onChange("time_start", e.target.value)}
                                        className={cx("input-time")}
                                        type={"time"}
                                    />
                                </div>
                                <div
                                    className={cx("end")}
                                >
                                    <label className={cx("label-time")}>{t("smartReport.timeEnd")}</label>
                                    <input
                                        value={value?.time_end}
                                        className={cx("input-time")}
                                        type={"time"}
                                        onChange={(e) => onChange("time_end", e.target.value)}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )
            default:
                return <></>
        }
    }
    return (
        <div>
            {listParamConfig?.map(pcf => {
                return (
                    <Fragment key={pcf?.label}>
                        {getElementConfig(pcf)}
                    </Fragment>
                )
            })}
        </div>
    )
}

export default FormParamAiConfig;